import React, { Component } from 'react';
import { Row, Col, Container, Form, Modal } from "react-bootstrap";
import moment from "moment";
import DateBlock from '../home/DateBlock';
import { gql } from "apollo-boost";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import * as Cookies from "es-cookie"
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import ReportTableData from './tableData';
import { HostelShimmer } from '../HostelAttendance/HostelShimmer';
import HostelAttendanceSection from '../HostelAttendance/HostelAttendanceSection';
import './_tableReportData.scss';
import {
  attachModuleGuard,
  AccessDeniedModal,
  AccessDeniedCard,
} from "../../../utils/moduleGuard";

// /hostel/attendance-report → granted by EITHER key (see MODULE_ROUTES in
// moduleAccessGuard — a route is allowed when ANY of its keys is granted).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const HOSTEL_ATTENDANCE_MODULE = ["Hostel_Attendance", "Hostel_Attendance_Report"];

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
    }
  }
`;

// ── Finance-style multi-select checkbox dropdown ──────────────────────────────
class CheckboxDropdown extends React.Component {
  constructor(props) { super(props); this.state = { open: false }; this.ref = React.createRef(); }
  componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
  componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
  handleOutside = (e) => { if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false }); };
  toggle = (id) => { const { value, onChange } = this.props; onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]); };
  render() {
    const { options, value, placeholder, onChange, disabled } = this.props;
    const { open } = this.state;
    const label = value.length === 0 ? placeholder : value.length === options.length ? `All (${options.length})` : value.length === 1 ? (options.find((o) => o.value === value[0])?.label || `${value.length} selected`) : `${value.length} selected`;
    return (
      <div ref={this.ref} style={{ position: "relative" }}>
        <div onClick={() => { if (!disabled) this.setState({ open: !open }); }} style={{ borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: value.length ? "#1f2937" : "#9ca3af", background: disabled ? "#f1f5f9" : "#f9fafb", cursor: disabled ? "not-allowed" : "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none", height: 42 }}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
          <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
        </div>
        {open && !disabled && (
          <div className="cbx-dd-panel" style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 240, overflowY: "auto" }}>
            {options.length === 0 ? (
              <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
            ) : (
              <>
                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))} style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                  <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />Select All
                </div>
                {options.map((o) => (
                  <div key={o.value} onClick={() => this.toggle(o.value)} style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                    <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                    <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

const FIN = {
  wrapper: { background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 },
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
  cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap", borderTopLeftRadius: 16, borderTopRightRadius: 16 },
  iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
  cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
  cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
  cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
  filterBar: { padding: "16px 24px", borderBottom: "1px solid #f3f4f6" },
  label: { fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block" },
  select: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%", height: 42 },
  btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
  err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
  content: { padding: "20px 24px" },
};

class HostelAttendanceReportHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branches: [],
      branchSearchval: "",
      branchSearch: 0,
      branchError: "",
      buildingSearch: "",
      buildingError: "",
      buildingName: "",
      floorError: "",
      floorSearch: "",
      getFloors: [],
      floorSelectedvalue: [],
      roomError: "",
      roomSearch: "",
      getRooms: [],
      roomSelectedvalue: [],
      loader: 0,
      noDateError: "",
      getBuildingFloorAndRoomDetails: [],
      showTable: false,
      defaultvalue: 0,
      startDateCalender: moment(new Date()).subtract(5, "day").startOf('day').unix(),
      endDateCalender: moment(new Date()).startOf('day').unix(),
      initialLoad: true,
      attendanceModalShow: false,
      allStudents: [],
      accessDeniedShow: false,
    };

    this.guard = attachModuleGuard(this, HOSTEL_ATTENDANCE_MODULE);
  }

  // "Mark Hostel Attendance" — opens the embedded HostelAttendanceSection modal, which
  // owns the actual marking/saving mutation. Gating the opener is what stops the write;
  // the button itself stays visible and clickable.
  openAttendanceModal = () => {
    if (!this.guard.requireEdit()) return;
    this.setState({ attendanceModalShow: true });
  };

  // Branch students from edu_students (resolves allocated students that are
  // missing from getNewEducationalStudents because they lack a class/section).
  // getAllotmentStudents takes a single branch_id, so fan it out across the header's
  // branch scope and concatenate.
  fetchBranchStudents = async () => {
    try {
      const results = await Promise.all(this.scopedBranchIds().map((branch_id) => this.props.client.query({
        query: gql`
          query($institute_id: Int, $branch_id: Int){
            getAllotmentStudents(institute_id: $institute_id, branch_id: $branch_id){
              student_id
              student_name
              roll_no
            }
          }
        `,
        variables: { institute_id: parseInt(Cookies.get("institutionid")), branch_id: branch_id },
        fetchPolicy: 'network-only',
      })));
      this.setState({ allStudents: results.flatMap((r) => (r.data && r.data.getAllotmentStudents) || []) });
    } catch (e) {
      console.error("fetchBranchStudents error", e);
      this.setState({ allStudents: [] });
    }
  };

  async componentDidMount() {
    // is_view === 0 → don't fetch anything. Every read here is an imperative
    // client.query(), so there's no graphql HOC to put a `skip` on — bailing out here is
    // what keeps the hostel attendance data off the wire. render() returns Access Denied
    // before it reads initialLoad, so leaving it true is fine.
    if (!this.guard.canView()) return;

    await this.getBranches();
    this.setState({ initialLoad: false });
    // Branch comes from the header (NavbarOne) — re-scope when it changes.
    this.offBranchScope = onBranchScopeChange(() => this.getBranches());
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  // The branches this report covers. There is no branch picker here any more.
  scopedBranchIds = () => (this.state.branches || []).map((b) => parseInt(b.id));

  getBranches = async () => {
    try {
      const result = await this.props.client.query({
        query: GET_BRANCHES,
        variables: { institution_id: parseInt(Cookies.get("institutionid")) },
        fetchPolicy: "network-only",
      });
      // The header's branch selection (NavbarOne) IS this report's branch filter.
      const branches = scopeBranches(result.data.getBranches || []);
      if (branches.length > 0) {
        this.setState({
          branches,
          buildingSearch: "", buildingError: "", getBuildingFloorAndRoomDetails: [],
          getRooms: [], roomSelectedvalue: [], getFloors: [], floorSelectedvalue: [], showTable: false,
        }, () => {
          this.getBuildingCreationDetails();
          this.fetchBranchStudents();
        });
      } else {
        this.setState({ branches: [], getBuildingFloorAndRoomDetails: [], allStudents: [] });
      }
    } catch (err) {
      console.error("hostel report getBranches error", err);
    }
  };

  // onBranchChange removed — the header (NavbarOne) owns branch selection now.

  // getBuildingCreationDetails takes a single branch_id, so fan it out across the
  // header's branch scope and concatenate — each building belongs to one branch.
  getBuildingCreationDetails = async () => {
    const results = await Promise.all(this.scopedBranchIds().map((branch_id) => this.props.client.query({
      query: gql`
      query($institute_id: Int!, $branch_id: Int!,$fromDate:String,$toDate:String){
        getBuildingCreationDetails(institute_id: $institute_id, branch_id:$branch_id,fromDate:$fromDate,toDate:$toDate) {
            hostel_building_id
            hostel_building_name
            floors_details{
              floor_id
              floor_name
              rooms_details{
                room_id
                room_name
                room_capacity
                capacity_details{
                  edu_student_id
                  attendance_status
                  attended_date
                }
              }
            }
        }
    }
      `,
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
        branch_id: branch_id,
        fromDate: this.state.startDateCalender.toString(),
        toDate: this.state.endDateCalender.toString(),
      },
      fetchPolicy: 'network-only'
    })))
    const allBuildings = results.flatMap((r) => (r.data && r.data.getBuildingCreationDetails) || [])
    if (allBuildings.length > 0) {
      let buildingDetails = allBuildings;
      if (buildingDetails.length > 0) {
        this.setState({ getBuildingFloorAndRoomDetails: buildingDetails, loader: 0, noDateError: "" })
      }
    }
  }

  handleInputChange = (e) => {
    let name = e.target.name
    let value = e.target.value

    if (name == "buildingSearch") {
      let getFloors = []
      let getRooms = []
      if (value != 0) {
        const selectedBuilding = this.state.getBuildingFloorAndRoomDetails.find(a => a.hostel_building_id == value);
        if (selectedBuilding) {
          selectedBuilding.floors_details.map((item) => {
            getFloors.push({ label: item.floor_name, value: item.floor_id })
          })
          selectedBuilding.floors_details.map((item) => {
            item.rooms_details.map((item1) => {
              getRooms.push({ label: item1.room_name, value: item1.room_id })
            })
          })
          this.setState({
            buildingSearch: value,
            buildingName: selectedBuilding.hostel_building_name,
            buildingError: "", floorSearch: "", floorError: "", roomSearch: "", roomError: "",
            getFloors: getFloors, getRooms: getRooms, floorSelectedvalue: getFloors, roomSelectedvalue: getRooms, showTable: false,
          })
        } else {
          this.setState({
            buildingSearch: "", buildingName: "", buildingError: "", floorSearch: "", floorError: "", roomSearch: "", roomError: "",
            getFloors: [], getRooms: [], floorSelectedvalue: [], roomSelectedvalue: [], showTable: false,
          })
        }
      }
    }
  }

  handleMultipleSelectInputChange = async (e, name) => {
    if (name === "floorSearch") {
      let floorSelectedvalue = [];
      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          const floorVal = e[i];
          floorSelectedvalue.push({ label: floorVal.label, value: floorVal.value });
        }
        let getRooms = [];
        floorSelectedvalue.map((item2) => {
          let roomsData = this.state.getBuildingFloorAndRoomDetails.filter((item3) => item3.hostel_building_id == this.state.buildingSearch)[0].floors_details.filter((item4) => item4.floor_id == item2.value);
          roomsData[0].rooms_details.map((item5) => {
            getRooms.push({ label: item5.room_name, value: item5.room_id })
          })
        })
        this.setState({
          floorSelectedvalue: floorSelectedvalue,
          floorError: "", roomError: "", getRooms: getRooms, roomSelectedvalue: getRooms, showTable: false,
        });
      } else {
        this.setState({
          floorSelectedvalue: [], getRooms: [], roomSelectedvalue: [], floorError: "", roomError: "", showTable: false,
        });
      }
    }

    if (name === "roomSearch") {
      let roomSelectedvalue = [];
      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          const roomVal = e[i];
          roomSelectedvalue.push({ label: roomVal.label, value: roomVal.value });
        }
        this.setState({ roomSelectedvalue: roomSelectedvalue, floorError: "", roomError: "", showTable: false });
      } else {
        this.setState({ roomSelectedvalue: [], floorError: "", roomError: "", showTable: false });
      }
    }
  }

  handleFloorChange = (ids) => {
    const sel = this.state.getFloors.filter((o) => ids.includes(o.value));
    this.handleMultipleSelectInputChange(sel, "floorSearch");
  }

  handleRoomChange = (ids) => {
    const sel = this.state.getRooms.filter((o) => ids.includes(o.value));
    this.handleMultipleSelectInputChange(sel, "roomSearch");
  }

  getDisplayData = (e) => {
    e.preventDefault();
    if (this.state.buildingSearch == "") {
      this.setState({ buildingError: "Please select Building" })
      return ""
    }
    if (!this.state.floorSelectedvalue.length) {
      this.setState({ floorError: "Please select Floor" })
      return ""
    }
    if (!this.state.roomSelectedvalue.length) {
      this.setState({ roomError: "Please select Room" })
      return ""
    }
    this.setState({ showTable: true });
  }

  applyCallback = (startDate, endDate) => {
    this.setState({
      startDateCalender: startDate.startOf('day').unix(),
      endDateCalender: endDate.startOf('day').unix(),
      buildingSearch: "", buildingError: "", buildingName: "",
      floorError: "", floorSearch: "", getFloors: [], floorSelectedvalue: [],
      roomError: "", roomSearch: "", getRooms: [], roomSelectedvalue: [],
      loader: 0, noDateError: "", showTable: false, getBuildingFloorAndRoomDetails: [],
    })
    setTimeout(() => {
      this.getBuildingCreationDetails();
    }, 100)
  }

  render() {
    // is_view === 0 → the hostel attendance data is never rendered, and the parent's
    // query is skipped so nothing is fetched. Deliberately ABOVE the initialLoad
    // shimmer: a denied user should see Access Denied immediately, not a loading
    // skeleton for data that will never arrive.
    if (!this.guard.canView()) {
      return (
        <div style={FIN.wrapper}>
          <AccessDeniedCard />
        </div>
      );
    }

    if (this.state.initialLoad) {
      return <HostelShimmer filters={5} />;
    }


    return (
      <div style={FIN.wrapper}>
        <Container fluid className="px-0">
          <div style={FIN.card}>
            {/* Header */}
            <div style={FIN.cardHeader} className="hostel-report-header">
              <div style={FIN.iconWrapper}><i className="fal fa-clipboard-check" /></div>
              <div style={FIN.cardTitleText}>
                <h5 style={FIN.cardTitle}>Hostel Attendance Report</h5>
                <span style={FIN.cardSubtitle}>Date-range attendance across buildings, floors &amp; rooms</span>
              </div>
              <div className="hostel-report-actions" style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <button style={FIN.btnPrimary} onClick={this.openAttendanceModal}>
                  <i className="fas fa-clipboard-list" /> Mark Hostel Attendance
                </button>
                <Form.Group className="customDate mb-0 hostel-report-datepicker" controlId="StartDate" style={{ width: 200, marginBottom: 0 }}>
                  <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end} stateData={this.props.stateData} data="hostel_Attendance_Report" />
                </Form.Group>
              </div>
            </div>

            {/* Filters */}
            <div style={FIN.filterBar}>
              <Row className="g-2 align-items-end">
                {/* No Branch picker — the header (NavbarOne) scopes this report. */}
                <Col xl={3} lg={3} md={6} sm={12} className="mb-2">
                  <label style={FIN.label}>Building</label>
                  <select style={FIN.select} name="buildingSearch" onChange={this.handleInputChange} value={this.state.buildingSearch}>
                    <option value={this.state.defaultvalue}>--Select--</option>
                    {[...this.state.getBuildingFloorAndRoomDetails]
                      .sort((a, b) => b.hostel_building_id - a.hostel_building_id)
                      .map(buildname => (
                        <option key={buildname.hostel_building_id} value={buildname.hostel_building_id}>{buildname.hostel_building_name}</option>
                      ))}
                  </select>
                  {this.state.buildingError ? <span style={FIN.err}>{this.state.buildingError}</span> : null}
                </Col>
                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                  <label style={FIN.label}>Floor</label>
                  <CheckboxDropdown
                    options={this.state.getFloors}
                    value={this.state.floorSelectedvalue.map(f => f.value)}
                    onChange={this.handleFloorChange}
                    placeholder="Select Floor(s)"
                    disabled={this.state.getFloors.length === 0}
                  />
                  {this.state.floorError ? <span style={FIN.err}>{this.state.floorError}</span> : null}
                </Col>
                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                  <label style={FIN.label}>Rooms</label>
                  <CheckboxDropdown
                    options={this.state.getRooms}
                    value={this.state.roomSelectedvalue.map(r => r.value)}
                    onChange={this.handleRoomChange}
                    placeholder="Select Room(s)"
                    disabled={this.state.getRooms.length === 0}
                  />
                  {this.state.roomError ? <span style={FIN.err}>{this.state.roomError}</span> : null}
                </Col>
                <Col xl={2} lg={3} md={6} sm={12} className="mb-2">
                  <label style={{ ...FIN.label, visibility: "hidden" }}>Get</label>
                  <button style={{ ...FIN.btnPrimary, width: "100%", background: "linear-gradient(135deg, rgb(16, 185, 129) 0%, rgb(5, 150, 105) 100%)" }} onClick={this.getDisplayData}>
                    <i className="fas fa-search" /> Get Report
                  </button>
                </Col>
              </Row>
            </div>

            {/* Content */}
            <div style={FIN.content}>
              {this.state.showTable && this.state.getBuildingFloorAndRoomDetails.length > 0 ? (
                <>
                  <ReportTableData stateData={this.state} buildingDetails={this.state.getBuildingFloorAndRoomDetails} getNewEducationalStudents={this.props.getNewEducationalStudents} allStudents={this.state.allStudents} />
                </>
              ) : this.state.noDateError != "" ? (
                <div style={{ textAlign: "center", padding: "30px 0", color: "#64748b" }}>
                  <div style={{ fontSize: 34, color: "#cbd5e1", marginBottom: 8 }}><i className="fal fa-clipboard" /></div>
                  <h6 style={{ color: "#64748b" }}>{this.state.noDateError}</h6>
                </div>
              ) : null}
            </div>
          </div>
        </Container>

        <Modal show={this.state.attendanceModalShow} onHide={() => this.setState({ attendanceModalShow: false })} size="xl" aria-labelledby="hostel-attendance-modal">
          <Modal.Header closeButton style={{ borderBottom: "none" }}>
            <Modal.Title style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", display: "flex", alignItems: "center", gap: 9 }}>
              <i className="fal fa-bed" style={{ color: "#7c3aed" }} />Mark Hostel Attendance
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ background: "#fff", padding: "0 8px 8px" }}>
            <HostelAttendanceSection embedded getNewEducationalStudents={this.props.getNewEducationalStudents} />
          </Modal.Body>
        </Modal>

        {/* Shown instead of opening the Mark Hostel Attendance modal when is_edit is
            missing. This module has no delete surface. */}
        <AccessDeniedModal
          show={this.state.accessDeniedShow}
          onHide={this.guard.hideAccessDenied}
        />
      </div>
    );
  }
}
export default withRouter(withApollo(HostelAttendanceReportHome));
